import { defineMessages } from 'react-intl'

const messages = defineMessages({
  competitivenessBasqueInstitute: {
    id: 'Footer.competitivenessBasqueInstitute',
    description: 'Texto para el footer, Insituto Vasco de Competitividad',
    defaultMessage: 'Instituto Vasco de Competitividad'
  },
  anInitiativeOf: {
    id: 'Footer.anInitiativeOf',
    description: 'Texto para el footer, una iniciativa de...',
    defaultMessage: 'Una iniciativa de'
  },
  spriGroup: {
    id: 'Footer.spriGroup',
    description: '[Mantener HTML] Texto para el mensaje central del footer',
    defaultMessage: 'Esta plataforma cuenta con la financiación del <strong>Grupo SPRI</strong>,<br /> agencia vasca de desarrollo empresarial'
  },
  privacy: {
    id: 'Footer.privacy',
    description: 'Texto de privacidad para el footer',
    defaultMessage: 'Privacidad'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/components/Footer/messages.js